import { assetStore } from './assetStore';
import { uploadAsset } from './uploadAsset';

/**
 * Store an image locally (content-hash → IndexedDB), kick off a background
 * cloud upload, and return its stable `asset://<id>` ref. The ref is usable
 * immediately (resolves to a local objectURL); once the upload lands the
 * resolver flips it to the CDN. Upload failure is swallowed — the asset stays
 * local-only and offline-safe.
 */
export async function ingestImage(blob: Blob): Promise<string> {
  const id = await assetStore.put(blob);
  void blob
    .arrayBuffer()
    .then((buf) => uploadAsset(id, buf, blob.type || 'image/png'))
    .catch(() => {});
  return `asset://${id}`;
}
